import React from "react";
import img1 from "../../../images/LandingPageImage/group1.webp";
import img2 from "../../../images/LandingPageImage/group2.webp";
import img3 from "../../../images/LandingPageImage/group3.webp";

const cards = [
  {
    id: 1,
    title: "Single Dashboard Campaigns",
    text: "Run Unified Campaigns effortlessly across WhatsApp with a single dashboard. Manage, schedule, and track all your messages in one place—boosting efficiency, consistency, and impact for every campaign.",
    image: img1,
  },
  {
    id: 2,
    title: "Personalized Engagement",
    text: "Guide your customers through Personalized Journeys that adapt to their actions and preferences. Deliver the right message at the right time, creating seamless, engaging experiences that drive loyalty and conversions.",
    image: img2,
  },
  {
    id: 3,
    title: "Smart Analytics",
    text: "Unlock the power of Actionable Insights! Analyze your WhatsApp campaigns with ease, understand customer behavior, and make data-driven decisions that boost engagement, improve strategy, and drive real results.",
    image: img3,
  },
];

const ThirdCardsSection = () => {
  return (
    <>
      <style>{`
        .hc-section {
          padding: 4rem 1.5rem;
        }

        .hc-container {
          max-width: 1200px;
          margin: 0 auto;
        }

        .hc-header {
          margin-bottom: 3rem;
        }

        .hc-header-title {
          font-size: 2.2rem;
          font-weight: 700;
          color: #9E104C !important;
          text-align: center;
          margin: 0 auto;
          max-width: 600px;
        }

        /* GRID */
        .hc-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 2rem;
          justify-items: center;
        }

        /* CARD */
        .hc-card {
          width: 100%;
          max-width: 380px;
          background: #FBFAF9;
          border-radius: 20px;
          overflow: hidden;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          transition: transform 0.3s ease;
        }

        .hc-card:hover {
          transform: translateY(-8px);
        }

        /* TOP SECTION */
        .hc-top {
          padding: 1.5rem;
          height: auto;
        }

        .hc-content {
          opacity: 0;
          transform: translateY(-60px);
          transition: opacity 0.3s ease, transform 0.4s ease;
        }

        .hc-card:hover .hc-content {
          opacity: 1;
          transform: translateY(0);
        }

        .hc-title {
          font-size: 1.4rem;
          font-weight: 800;
          margin-bottom: 0.8rem;
          color: #111827;
        }

        .hc-card:hover .hc-title {
          font-size: 1.55rem;
        }

        .hc-text {
          font-size: 1rem;
          line-height: 1.5;
          color: #4b5563;
          font-weight: 500;
        }

        /* IMAGE */
        .hc-image-wrap {
          width: 100%;
          height: 250px;
          overflow: hidden;
          border-bottom-left-radius: 20px;
          border-bottom-right-radius: 20px;
        }

        .hc-image-wrap img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transform: scale(1.15);
          transition: transform 0.5s ease;
        }

        .hc-card:hover .hc-image-wrap img {
          transform: scale(1);
        }

        /* TABLET */
        @media (max-width: 992px) {
          .hc-section {
            padding: 3rem 1.5rem;
          }

          .hc-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 2rem;
          }

          .hc-header-title {
            font-size: 2rem;
          }

          .hc-card {
            max-width: 100%;
          }

          .hc-image-wrap {
            height: 230px;
          }
        }

        /* MOBILE */
        @media (max-width: 640px) {
          .hc-grid {
            grid-template-columns: 1fr;
          }

          .hc-top {
            padding: 1.3rem;
          }

          .hc-content {
            opacity: 1;
            transform: translateY(0);
          }

          .hc-card:hover .hc-title {
            font-size: 1.45rem;
          }

          .hc-image-wrap {
            height: 220px;
          }

          .hc-header-title {
            font-size: 1.8rem;
          }
        }

        /* EXTRA SMALL MOBILE */
        @media (max-width: 420px) {
          .hc-header-title {
            font-size: 1.6rem;
          }

          .hc-image-wrap {
            height: 200px;
          }
        }
      `}</style>

      <section className="hc-section">
        <div className="hc-container">
          <div className="hc-header">
            <h2 className="hc-header-title">
              Built for Every Business on WhatsApp
            </h2>
          </div>

          <div className="hc-grid">
            {cards.map((card) => (
              <article key={card.id} className="hc-card">
                <div className="hc-top">
                  <div className="hc-content">
                    <h3 className="hc-title">{card.title}</h3>
                    <p className="hc-text">{card.text}</p>
                  </div>
                </div>

                <div className="hc-image-wrap">
                  <img src={card.image} alt={card.title} />
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ThirdCardsSection;
